<<template>
<div ref="basePanel">    
    <param-panel :config="config" :rs="rs" /><pager-panel :crowCount="config.rowCount" :cpageNo="config.pageNo" :cpageSize="config.pageSize"
    @CFHandler="CFHandler" :selIdx="selIdx" :rightList="config.rights"/>
      </pager-panel><list-panel :config="config" :isAutoLoad='1' :rs="rs" @updateIdx="updateIdx" :selIdx="selIdx" />
    <component v-if="isShowDetail" v-bind:is="detailView" :url="config.url" @back="back"
    :action="detailAction" :detailData="detailData" :rs="rs" :autoId="config.autoId" :config="config" >
        <a class="btn btn-default" @click="back">{{$rs["btn_back"]}}</a>
    </component>
</div>
</template>


<script>
import data from "./data";
import mixin from "@/fui/mixin";

export default {
  created: function() {
    if (this.config.dept){
      this.config.dept.forEach(d=>{
        this.config.params.dept.options.push({value:d.deptNo, text: d.deptName})
      })
    }
  },
  data() {
    return {
      config: data
    };
  },
  methods: {
    del(index, el) {
      const md = { autoID: el.autoID };
      this.$delAndReload(this.config.url, md, this.config, this.delCallback)
    },
    delCallback(rs){
      if (rs) this.$extend(this.config, rs )
    },
    initDetail(el){
        this.$getData(this.config.url + "detail?deptNo=" + el.deptNo + "&empId=" + el.empId + "&job=" + el.job + this.$urlSq(), this.openDetail)
     
    },
    openDetail(data){
      if (data && data.rs) {
        this.detailData.salaryEmp = data.salaryEmp
        if (!this.detailData.salaryEmp) this.detailData.salaryEmp = {empId:this.detailData.empId, empName: this.detailData.empName}
        this.detailData.salaryJob = data.salaryJob
        if (!this.detailData.salaryJob) this.detailData.salaryJob = {}
        this.isShowDetail = true;
      }
    }
  },
  components: {
    "detail-panel": () => import("./detail")
  },
  mixins:[mixin.list]
};
</script>
